import { Badge } from '@ps/isp-web-component-library';
import { PriceBoost } from '@ps/isp-web-component-library/icons/PriceBoost';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Selection } from '@swf/sports/components';
import PreviousPrice from '@swf/sports/components/MarketTemplate/components/PreviousPrice/PreviousPrice';

import type { MarketDynamicBanner } from '../../../../model/types';
import EventStatus from '../components/EventStatus';

import { TXTWCL_odds_boost, TXTWCL_odds_boost_selections } from './Oddsboost.messages.json';
import styles from './Oddsboost.scss';

const OddsBoostDynamicBanner: React.FC<MarketDynamicBanner> = ({
  event,
  market,
  eventType,
  competition
}) => {
  const { formatMessage } = useRegulatoryIntl();
  const [runner] = market.runners;
  const shouldDisplayPreviousPrice = runner.previousWinRunnerOdds.length > 0;

  return (
    <>
      <div className={styles.eventStatusContainer}>
        <EventStatus
          badge={
            <Badge
              icon={PriceBoost}
              iconLabel={formatMessage(TXTWCL_odds_boost_selections)}
              text={formatMessage(TXTWCL_odds_boost)}
              size="base"
            />
          }
          startTime={event.eventStartTime}
          isTurnInPlay={market.turnInPlayEnabled}
          isInPlay={market.inPlay}
        />
      </div>
      <div className={styles.marketContainer}>
        <span className={styles.marketName}>{runner.runnerName}</span>
        <div className={styles.priceContainer}>
          <div className={styles.nowPrice}>
            <Selection
              competitionId={competition.competitionId}
              eventId={event.eventId}
              eventTypeId={eventType.eventTypeId}
              handicap={runner.handicap}
              key={runner.selectionId}
              legTypes={market.legTypes}
              marketId={market.marketId}
              marketStatus={market.marketStatus}
              marketType="ODDS_BOOST"
              odds={runner.winRunnerOdds}
              runnerResultType={runner.resultType}
              runnerStatus={runner.runnerStatus}
              selectionId={runner.selectionId}
              size="base"
              startTime={event.eventStartTime}
              selectionText={
                shouldDisplayPreviousPrice
                  ? (isSelected: boolean) => (
                      <PreviousPrice
                        odds={runner.previousWinRunnerOdds[0]}
                        isSelected={isSelected}
                      />
                    )
                  : undefined
              }
              isMultiline={shouldDisplayPreviousPrice}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OddsBoostDynamicBanner;
